import { createPropType } from '../utils';

export default function (min, max) {
  return createPropType(function (props, propName, componentName) {
    var value = props[propName];

    if (value < min || value > max) {
      return new Error('Invalid prop ' + propName + ' of ' + componentName + ', should between ' + min + ' and ' + max + '.');
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/libs/props/range.js
// module id = 320
// module chunks = 0